module.exports = {"id":"162052","name":"David Ousted","rating":"73","photo":"./data/images/photos/0/162052.png","club":{"name":"D.C. United","logo":"./data/images/clubs/D.C.United.png"},"positions":["G"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/DavidOusted0.json
// module id = 999
// module chunks = 0